import React, { useState } from 'react';
import { prefillPick } from '../repository/draftsRepository';

interface PrefillPickModalProps {
    draftUuid: string;
    pickNumber: number;
    drafter: string;
    onClose: () => void;
    onSave: () => void;
}

const PrefillPickModal: React.FC<PrefillPickModalProps> = ({
    draftUuid,
    pickNumber,
    drafter,
    onClose,
    onSave
}) => {
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (!value.trim()) {
            setError('Pick value is required');
            return;
        }

        setLoading(true);

        const result = await prefillPick(draftUuid, pickNumber, value.trim());

        if ('error' in result) {
            setError(result.error);
            setLoading(false);
            return;
        }

        onSave();
    };

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal">
                <div className="modal-header">
                    <h3>Prefill Pick #{pickNumber}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="prefill-meta">
                    Prefilling for <strong>{drafter}</strong>
                </div>
                <form onSubmit={handleSubmit} className="modal-form">
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-group">
                        <label htmlFor="prefillValue">Pick Value</label>
                        <input
                            type="text"
                            id="prefillValue"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder="e.g. keeper pick, forfeited..."
                            disabled={loading}
                            autoFocus
                        />
                    </div>
                    <div className="modal-actions">
                        <button
                            type="button"
                            className="btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={loading || !value.trim()}
                        >
                            {loading ? 'Saving...' : 'Prefill'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PrefillPickModal;
